import React, { useState } from "react";
import styles from "../../styles/components/userEdit.module.scss";
import Icons from "../../public/assets/svg";
import Loader from "../../components/Loader";
import SuccessModal from "../../pages/successModal";
import BasicForm2 from "../BasicForm2";
import BasicForm3 from "../BasicForm3";
import BasicForm from "../basicForm";
import endpoints from "../../utility/endpoints";
import axios from "axios";
import router from "next/router";
import _ from "lodash";
import { sessionTimeOutCheck, checkExpiry } from "../../redux/global/actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
const ModalExample = (props) => {
  //console.log("Edit User props", props);
  const landscapData = 
  {
    "field_form_field_title": "Landscape",
    "field_label": "Landscape",
    "field_input_type": "Dropdown",
    "field_related_dropdown": null,
    "field_options": [
      "Cordillera",
      "Fusion",
      "Global",
      "Sirius",
      "U2K2"
    ],
    "field_input": "Select Landscape",
    "field_message_ip_error_message": "Landscape is mandatory",
    "field_required": "1",
    "field_dropdown_option_component": [
        {
            "field_title": "",
            "field_options": []
        }
    ],
    "field_editable": "",
    "field_column_size": ""
};
  //console.log("failure", props.editUserSucessFailure[1].field_message[0]);
  const [formData, setFormData] = useState([]);

  const [state, setState] = useState({});

  const [loader, setLoader] = useState(false);
  const leadPlatformData = props.globalData.lead_platform_main_component[0];
  const areaData = props.globalData.lead_platform_main_component[1];
  const subAreaData = props.globalData.lead_platform_main_component[2];

  const clusterData = props.globalData.cluster_main_component[0];
  const mcoData = props.globalData.cluster_main_component[1];
  const countryData = props.globalData.cluster_main_component[2];

  clusterData.field_related_dropdown = "mco";
  mcoData.field_related_dropdown = "";
  //  if (props.userToBeEdited.leadPlatform.length>0){
  //   areaData.nowValues = areaData.field_dropdown_option_component.filter(
  //     (item) => item.field_title == props.userToBeEdited.leadPlatform
  //   )[0].field_options;
  //  }
  //  if (props.userToBeEdited.area.length>0){
  //      subAreaData.nowValues = subAreaData.field_dropdown_option_component.filter(
  //        (item) => item.field_title == props.userToBeEdited.area
  //      )[0].field_options;
  //  }

  // if (props.userToBeEdited.cluster.length > 0) {
  //  mcoData.nowValues = mcoData.field_dropdown_option_component.filter(
  //    (item) => item.field_title == props.userToBeEdited.cluster
  //  )[0].field_options;
  // }

  const [formData1, setFormData1] = useState([clusterData, mcoData]);
  const [formData2, setFormData2] = useState([
    leadPlatformData,
    areaData,
    subAreaData,
  ]);
  const [formData3, setFormData3] = useState([landscapData]);
  React.useEffect(() => {
    setState(props.userToBeEdited);
  }, []);

  //console.log(props, "props of edit user");
  //console.log(props.editFormDrupalData.component.content.field_title);

  const inputChange = (e) => {
    setState({ ...state, userType: e.target.value });
    //console.log("editable  data  ------", e.target.value);
  };

  const [getFormValues, setGetFormValues] = React.useState(false);
  const [emptyFormValues, setEmptyFormValues] = React.useState(false);

  const submitDemandForm = () => {
    //console.log("here  ---- on submit", state);
    if (
      state.userType == "firstGfcf" ||
      state.userType == "gfcf" ||
      state.userType == "firstLevelGPMApprover" ||
      state.userType == "GPMapprover" || state.userType == "businessUserRegionWise"
||  state.userType == "landscape"
    ) {
      setGetFormValues(true);
    } else {
      submitForm({ ...state, userType: state.userType });
      setGetFormValues(false);
    }
  };

  const recievedFormValues = (formState) => {
    //console.log("state of the form of the state ---edit modal ----", formState);
    //setState({ ...state, ...formState });
    submitForm({ ...state, ...formState, userType: state.userType });
    setGetFormValues(false);
  };

  let toSend = {};
  const submitForm = async (finalEditedState) => {
    //console.log("submit form", getFormValues);
    if (
      finalEditedState.userType == "firstGfcf" ||
      finalEditedState.userType == "gfcf" || finalEditedState.userType == "businessUserRegionWise"
    ) {
      toSend = {
        email: finalEditedState.email,
        toUpdateUser: {
          userType: finalEditedState.userType,
          mco: finalEditedState.mco,
          cluster: finalEditedState.cluster,
          leadPlatform:finalEditedState.leadPlatform,
          area:finalEditedState.area,
          subArea:finalEditedState.subArea,
        },
      };
    } else if (
      finalEditedState.userType == "firstLevelGPMApprover" ||
      finalEditedState.userType == "GPMapprover"
    ) {
      //console.log("final state --", finalEditedState);
      toSend = {
        email: finalEditedState.email,
        toUpdateUser: {
          userType: finalEditedState.userType,
          leadPlatform: finalEditedState.leadPlatform,
          area: finalEditedState.area,
          subArea: finalEditedState.subArea,
        },
      };
    } else if (finalEditedState.userType == "gCad") {
      toSend = {
        email: finalEditedState.email,
        toUpdateUser: {
          userType: finalEditedState.userType,
          mco: "Global",
          cluster: "Global",
        },
      };
    }
else if (finalEditedState.userType == "landscape") {
      if(finalEditedState.landscape=='Global'){finalEditedState.landscapeId='0';}
      if(finalEditedState.landscape=='Fusion'){finalEditedState.landscapeId='1';}
      if(finalEditedState.landscape=='Sirius'){finalEditedState.landscapeId='2';}
      if(finalEditedState.landscape=='Cordillera'){finalEditedState.landscapeId='3';}
      if(finalEditedState.landscape=='U2K2'){finalEditedState.landscapeId='4';}
      toSend = {
        email: finalEditedState.email,
        toUpdateUser: {
          userType: finalEditedState.userType,
          landscape:finalEditedState.landscape,
          landscapeId:finalEditedState.landscapeId,
        },
      };
    } 
    else if (finalEditedState.userType == "infosec") {
      toSend = {
        email: finalEditedState.email,
        toUpdateUser: {
          userType: finalEditedState.userType,
        },
      };
    }  
   else {
      toSend = {
        email: finalEditedState.email,
        toUpdateUser: {
          userType: finalEditedState.userType,
        },
      };
    }
    //console.log(toSend, "final state to send");
    try {
      let authCheck = JSON.parse(localStorage.getItem("auth")).data;
      let expiryStatus = await props.checkExpiry(authCheck);
      setLoader(true);

      if (expiryStatus) {
        let auth = JSON.parse(localStorage.getItem("auth")).data;
        const resp = await axios({
          method: "PUT",
          url: `${endpoints.baseUrl}/user/updateUserDetails`,
          data: toSend,
          headers: {
            Authorization: `${auth.accessToken}|${auth.email}`,
          },
        });
        //console.log("respose all user ", resp.data.data);
        setLoader(false);
        if (resp.data.code == 403) {
          setLoader(false)
          props.sessionTimeOutCheck(true);
          // alert("unauthorized user")
        } else if (resp.data.code == 401 || resp.data.code == 402) {
          props.setFail(true);
          props.setedituser(false);
          props.getUserData();
          props.setSuccessModal(true);
          props.setMessage(props.editUserSucessFailure[1].field_message[0]);
          // alert(resp.data.message)
        } else if (resp.data.code == 200) {
          // alert("user Edited")
          props.setFail(false);
          props.setedituser(false);
          props.userEdited()
          props.setSuccessModal(true);
          props.setMessage(props.editUserSucessFailure[0].field_message[0]);
         
        } else if (resp.data.code == 405) {
          props.setFail(true);
          props.setedituser(false);
          props.getUserData();
          props.setSuccessModal(true);
          props.setMessage(resp.data.message);
        }
      } else {
        setLoader(false)
        props.sessionTimeOutCheck(true);
      }
    } catch (e) {
      //console.log("eroor", e);
      // router.push("/login");
    }
    //console.log(toSend, "state of final form ");
  };

  return (
    <div className={styles.editModalWrapper}>
      <div className={styles.modalBox}>
        <div className={styles.modalHeader}>
          <p className={styles.content}>
            {_.get(
              props,
              "editFormDrupalData.component.content.field_title",
              ""
            )}
          </p>
        </div>
        <div className={styles.modalBody}>
          <div className={styles.formGroup}>
            <label className={styles.mainLabel}>
              {_.get(
                props,
                "editFormDrupalData.component.content.field_label",
                ""
              )}
            </label>
            <div className={styles.inputGroupWrapper} onChange={inputChange}>
             
              <label className={styles.radioWrapper}>
                <span className={styles.subLabel}>Support</span>
                <input
                  type="radio"
                  className={styles.radioBox}
                  name="userTypeEdit"
                  value="supportStatus"
                  checked={state.userType == "supportStatus"}
                />
                <span className={styles.radioCheckmark}></span>
              </label>
              <label className={styles.radioWrapper}>
                <span className={styles.subLabel}>Admin</span>
                <input
                  type="radio"
                  className={styles.radioBox}
                  name="userTypeEdit"
                  value="admin"
                  checked={state.userType == "admin" ? true : false}
                />
                <span className={styles.radioCheckmark}></span>
              </label>

              <label className={styles.radioWrapper}>
                <span className={styles.subLabel}>First Level GFCF</span>
                <input
                  type="radio"
                  className={styles.radioBox}
                  name="userTypeEdit"
                  value="firstGfcf"
                  checked={state.userType == "firstGfcf"}
                />
                <span className={styles.radioCheckmark}></span>
              </label>

              <label className={styles.radioWrapper}>
                <span className={styles.subLabel}>Second Level GFCF</span>
                <input
                  type="radio"
                  className={styles.radioBox}
                  name="userTypeEdit"
                  value="gfcf"
                  checked={state.userType == "gfcf"}
                />
                <span className={styles.radioCheckmark}></span>
              </label>

              <label className={styles.radioWrapper}>
                <span className={styles.subLabel}>First Level GPM</span>
                <input
                  type="radio"
                  className={styles.radioBox}
                  name="userTypeEdit"
                  value="firstLevelGPMApprover"
                  checked={state.userType == "firstLevelGPMApprover"}
                />
                <span className={styles.radioCheckmark}></span>
              </label>

              <label className={styles.radioWrapper}>
                <span className={styles.subLabel}>Second Level GPM</span>
                <input
                  type="radio"
                  className={styles.radioBox}
                  name="userTypeEdit"
                  value="GPMapprover"
                  checked={state.userType == "GPMapprover"}
                />
                <span className={styles.radioCheckmark}></span>
              </label>

              <label className={styles.radioWrapper}>
                <span className={styles.subLabel}>GCAD</span>
                <input
                  type="radio"
                  className={styles.radioBox}
                  name="userTypeEdit"
                  value="gCad"
                  checked={state.userType == "gCad"}
                />
                <span className={styles.radioCheckmark}></span>
              </label>
              <label className={styles.radioWrapper}>
                <span className={styles.subLabel}>End User</span>
                <input
                  type="radio"
                  className={styles.radioBox}
                  name="userTypeEdit"
                  value="endUser"
                  checked={state.userType == "endUser"}
                />
                <span className={styles.radioCheckmark}></span>
              </label>
              <label className={styles.radioWrapper}>
                <span className={styles.subLabel}>Internal User</span>
                <input
                  type="radio"
                  className={styles.radioBox}
                  name="userTypeEdit"
                  value="internalUser"
                  checked={state.userType == "internalUser"}
                />
                <span className={styles.radioCheckmark}></span>
              </label>

              <label className={styles.radioWrapper}>
                <span className={styles.subLabel}>
                  Business User – Regionwise
                </span>
                <input
                  type="radio"
                  className={styles.radioBox}
                  name="userTypeEdit"
                  value="businessUserRegionWise"
                  checked={state.userType == "businessUserRegionWise"}
                />
                <span className={styles.radioCheckmark}></span>
              </label>
              <label className={styles.radioWrapper}>
                <span className={styles.subLabel}>QR Manager</span>
                <input
                  type="radio"
                  className={styles.radioBox}
                  name="userTypeEdit"
                  value="qrManager"
                  checked={state.userType == "qrManager"}
                />
                <span className={styles.radioCheckmark}></span>
              </label>
               <label className={styles.radioWrapper}>
                <span className={styles.subLabel}>Landscape</span>
                <input
                  type="radio"
                  className={styles.radioBox}
                  name="userTypeEdit"
                  value="landscape"
                  checked={state.userType == "landscape"}
                />
                <span className={styles.radioCheckmark}></span>
              </label>
              <label className={styles.radioWrapper}>
                <span className={styles.subLabel}>Infosec</span>
                <input
                  type="radio"
                  className={styles.radioBox}
                  name="userTypeEdit"
                  value="infosec"
                  checked={state.userType == "infosec"}
                />
                <span className={styles.radioCheckmark}></span>
              </label>
            </div>
          </div>
          {loader ? <Loader /> : null} 
		{ state.userType ==  "businessUserRegionWise" ? (
            <div className={styles.basicFormWrapper}>
              <BasicForm
                data={formData1}
                sendFormValues={recievedFormValues}
                getFormValues={getFormValues}
                emptyFormValues={emptyFormValues}
                formType="userAccessEdit"
                params="userAccessEdit"
                // editState={state}
                setGetFormValues={setGetFormValues}
                demandEditData={props.userToBeEdited}
                userType={state.userType}
                type="form"
              />
            </div>
		): null
    }
    {state.userType == "firstGfcf" || state.userType == "gfcf" ? (
          <div className={styles.basicFormWrapper}>
            <>

             <BasicForm2
                  data={[...formData1,...formData2] }
                  sendFormValues={recievedFormValues}
                  getFormValues={getFormValues}
                  emptyFormValues={emptyFormValues}
                  formType="userCreateData"
                  notRequired={['Area','Sub Area','MCO','Lead Platform']}
                  // editState={state}
                  demandEditData={props.userToBeEdited}
                  type="user"
                  setGetFormValues={setGetFormValues}
                  params="userAccess"
                />              

           {/*  <BasicForm2
              data={formData2}
              sendFormValues={recievedFormValues}
              getFormValues={getFormValues}
              emptyFormValues={emptyFormValues}
              formType="userAccessEdit"
              params="userAccessEdit"
              // editState={state}
              demandEditData={props.userToBeEdited}
              setGetFormValues={setGetFormValues}
              type="form"
            />
            <BasicForm
                data={formData1}
                sendFormValues={recievedFormValues}
                getFormValues={getFormValues}
                emptyFormValues={emptyFormValues}
                formType="userAccessEdit"
                params="userAccessEdit"
                // editState={state}
                setGetFormValues={setGetFormValues}
                demandEditData={props.userToBeEdited}
                userType={state.userType}
                type="form"
              />  */}
            </>
          </div>
          ) : null}
          { state.userType == "firstLevelGPMApprover" ||
            state.userType == "GPMapprover" ? (
            <div className={styles.basicFormWrapper}>
              <BasicForm2
                data={formData2}
                sendFormValues={recievedFormValues}
                getFormValues={getFormValues}
                emptyFormValues={emptyFormValues}
                notRequired={['Area','Sub Area','MCO']}
                formType="userAccessEdit"
                params="userAccessEdit"
                // editState={state}
                demandEditData={props.userToBeEdited}
                setGetFormValues={setGetFormValues}
                type="form"
              />
            </div>
          ) : null}
          { state.userType == "landscape"  ? (
          <div className={styles.basicFormWrapper}>
            <BasicForm3
              data={formData3}
              sendFormValues={recievedFormValues}
              getFormValues={getFormValues}
              emptyFormValues={emptyFormValues}
              notRequired={['Area','Sub Area','MCO']}
              formType="userAccessEdit"
              params="userAccessEdit"
              // editState={state}
              demandEditData={props.userToBeEdited}
              setGetFormValues={setGetFormValues}
              type="form"
            />
          </div>
        ): null}
        </div>
        <div className={styles.modalFooter}>
          <div className={styles.combinedBtn}>
            <span
              className={styles.rowBtn}
              onClick={() => {
                props.setedituser(false);
                document.body.style.overflow = "unset";
              }}
            >
              Cancel
            </span>
            <span
              className={styles.exportListBtn}
              onClick={() => {
                submitDemandForm();
              }}
            >
              Edit User
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  //console.log("state", state);
  return {
    session: state.session.session,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    sessionTimeOutCheck: bindActionCreators(sessionTimeOutCheck, dispatch),
    checkExpiry: bindActionCreators(checkExpiry, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalExample);

